'use strict';
const $ = jQuery.noConflict();
$(function() {

	const faqBlock = {

		init: function() {
			this.cacheDOM();
			if (this.$items.length) {
				this.bindEvents();
			}
		},

		cacheDOM: function() {
			this.$block = $('.js-faq-block');
			this.$items = this.$block.find('.js-faq-item');
		},

		bindEvents: function() {
			this.$items.find('.js-faq-trigger').on('click', this.onTriggerClick.bind(this));
		},

		onTriggerClick: function(e) {
			e.preventDefault();

			const $item = $(e.currentTarget).closest('.js-faq-item');
			const isActive = $item.hasClass('is-active');

			this.$items.not($item).each((index, el) => this.closeItem($(el)));

			if (isActive) {
				this.closeItem($item);
			} else {
				this.openItem($item);
			}
		},

		openItem: function($item) {
			$item.addClass('is-active');
			$item.find('.js-faq-trigger').first().attr('aria-expanded', 'true');
			$item.find('.js-faq-answer').first().stop(true, true).slideDown(300);
		},

		closeItem: function($item) {
			$item.removeClass('is-active');
			$item.find('.js-faq-trigger').first().attr('aria-expanded', 'false');
			$item.find('.js-faq-answer').first().stop(true, true).slideUp(300);
		},

	};

	faqBlock.init();
});
